/**
 * Les phrases de l'accueil public de La Taverne, validees par Nicolas sur les deux planches (bureau et telephone,
 * 23 octobre 2026). Les codes fermes sont des `Record<Code, texte>`, comme dans `regie-texts.ts`.
 */

/** L'invitation publique du serveur Discord La Kavalry (celle du site kavaliero.fr). */
export const DISCORD_INVITATION = "https://discord.gg/hKSByN9M9S";

/** La chaine Twitch. */
export const TWITCH_CHAINE = "https://www.twitch.tv/kavalierogamedev";

/** Le fuseau des heures montrees : celui de la chaine, pas celui du visiteur. */
export const FUSEAU = "Europe/Paris";

export const BANDEAU_ALT = "Le château de Kavaliero au crépuscule, le chevalier et son écuyer";
export const BANDEAU_SRC = "/images/taverne-banniere.webp";

/** Les deux etats de la porte : un badge, un titre (sauf en direct, ou c'est celui du stream), un sous-titre, un bouton. */
export const ACCUEIL = {
  direct: {
    badge: "LES PORTES SONT OUVERTES",
    /** Quand la base ne connait pas le titre du stream : le meme que hors ligne, faute d'un titre a montrer. */
    titreParDefaut: "Bienvenue à La Taverne",
    boutonTwitch: "Entrer sur le stream",
  },
  horsLigne: {
    badge: "LES PORTES SONT CLOSES",
    titre: "Bienvenue à La Taverne",
    sousTitre: "Le château dort. Passe sur le Discord pour savoir quand les portes rouvrent.",
    boutonTwitch: "Suivre sur Twitch",
  },
  boutonDiscord: "Rejoindre La Kavalry",
} as const;

/** Le sous-titre en direct : `<jeu> · depuis <HH:MM>`, ou `depuis <HH:MM>` seul sans jeu. `heure` vide : le jeu seul. */
export function sousTitreDirect(jeu: string | null, heure: string | null): string {
  const depuis = heure === null ? null : `depuis ${heure}`;
  return [jeu, depuis].filter((morceau) => morceau !== null && morceau !== "").join(" · ");
}

/** L'heure d'ouverture, a l'heure de Paris : `19:02`. `null` si la date est illisible. */
export function heureDeParis(iso: string | null): string | null {
  if (iso === null) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat("fr-FR", {
    timeZone: FUSEAU,
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export type CodeCarte = "buzzer" | "cartes" | "kavalry";
export type CodeEtat = "bientot" | "preparation" | "ouvert";

export const ETATS: Record<CodeEtat, string> = {
  bientot: "Bientôt",
  preparation: "En préparation",
  ouvert: "Ouvert",
};

/** Les trois cartes. `texteTel` : la phrase plus courte de la planche du telephone, quand elle differe. */
export const CARTES: Record<
  CodeCarte,
  { titre: string; texte: string; texteTel?: string; etat: CodeEtat }
> = {
  buzzer: {
    titre: "Le buzzer",
    texte: "Le premier qui appuie a la main. Joue depuis ton téléphone, pendant le stream.",
    texteTel: "Le premier qui appuie a la main, depuis ton téléphone.",
    etat: "bientot",
  },
  cartes: {
    titre: "Les cartes du château",
    texte: "Collectionne les cartes des habitués et des héros du stream.",
    etat: "preparation",
  },
  kavalry: {
    titre: "La Kavalry",
    texte: "Le Discord de la communauté : la Gazette, les concours, les nouvelles du château.",
    texteTel: "Le Discord : la Gazette, les concours, les nouvelles.",
    etat: "ouvert",
  },
};

/** L'ordre des cartes sur la page. */
export const ORDRE_DES_CARTES: readonly CodeCarte[] = ["buzzer", "cartes", "kavalry"];
